import { Component, computed, inject, input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ServicePortalApi } from '../../../api/api';
import { RoleMapper, RoleMapperListInput } from '../../../api/types';
import {
  SynButtonComponent,
  SynergyFormsModule,
  SynOptionComponent,
  SynSelectComponent,
} from '@synergy-design-system/angular';
import { FormsModule, NgForm, ReactiveFormsModule } from '@angular/forms';
import { ClientRoleMappers } from '../../types';


@Component({
  selector: 'app-role-mappers',
  template: `
    <div class="flex-row gap-2 align-center margin-bottom-1">
      <p i18n="@@client-role-mappers-description">
        You can map specific roles of other clients if the other client has marked their role as publicly available
        or you have admin access to the other client.
      </p>
    </div>

    <form #form=ngForm (submit)="onSubmit(form)" class="form-width-large">
      @for (clientMapper of availableWithoutSelf(); track clientMapper.clientId) {
        <div class="flex-row gap-1 margin-bottom-1">
          <syn-select [clearable]="true" [multiple]="true" [label]="clientMapper.clientId" [maxOptionsVisible]="5"
                      [(ngModel)]="clientMapper.model" [name]="clientMapper.clientId"
                      style="width: 100%">
            @for (mapper of clientMapper.available; track mapper.roleId) {
              <syn-option [value]="mapper.roleId">
                {{ mapper.roleName }}
              </syn-option>
            }
          </syn-select>
        </div>
      }
      <div class="flex-row">
        <syn-button variant="filled" type="submit" style="margin-left: auto" [disabled]="!form.dirty">
          <span i18n="@@save-changes">Save Changes</span>
        </syn-button>
      </div>
    </form>
  `,
  styles: [
    `
    `,
  ],
  imports: [
    SynSelectComponent,
    SynOptionComponent,
    SynButtonComponent,
    SynergyFormsModule,
    FormsModule,
    ReactiveFormsModule,
  ],
})
export class RoleMappersComponent {
  id = inject(ActivatedRoute).snapshot.params['id'];
  api = inject(ServicePortalApi);
  router = inject(Router);

  available = input.required<ClientRoleMappers[]>();

  availableWithoutSelf = computed(() => {
    return this.available().filter((mapper) => {
      return mapper.available[0]?.containerId !== this.id;
    });
  });

  onSubmit(form: NgForm) {
    // Map from client ID to mapped role IDs
    const values: Record<string, string[]> = form.value;
    const mappers: RoleMapper[] = [];
    for (const client of this.available()) {
      const clientRoleIds = values[client.clientId];
      if (!clientRoleIds) continue;

      for (const mapper of client.available) {
        if (clientRoleIds.includes(mapper.roleId)) {
          mappers.push(mapper);
        }
      }
    }
    const list: RoleMapperListInput = { mappers };
    this.api.updateRoleMappers(this.id, list, (result) => {
      console.log('Updated', result);
    });
    form.form.markAsPristine();
  }
}
